export default {
    name: 'CostAnalysis',
    data() {
        return {
            Time: '',
            Detail: null
        };
    },
    mounted() {
        window.model = this;
        this.load();
    },
    methods: {
        async load() {
            var result = await this.$api.getCostAnalysis();

            var col = {
                title: "操作",
                data: "Time",
                render(data, type, row, meta) {
                    return `<a class="btn btn-md btn-default btn-read-more" onclick="window.model.showDetail('${data}')">檢視圖表</a>`;
                }
            };
            result.Month.Column.push(col);
            result.Quanrter.Column.push(col);
            result.Year.Column.push(col);

            this.createDataTable('#tableMonth', result.Month.Column, result.Month.Data, {
                bSort: false, searching: false, paging: false, bInfo :false,
                buttons: [{
                    extend: "excelHtml5",
                    className: "hide",
                    autoFilter: true,
                    text: "excel",
                    title: "生產成本分析"
                }, {
                    extend: "csv",
                    className: "hide",
                    autoFilter: true,
                    text: "csv",
                    title: "生產成本分析"
                }]
            });

            this.createDataTable('#tableQuanrter', result.Quanrter.Column, result.Quanrter.Data, {
                bSort: false, searching: false, paging: false, bInfo :false,
                buttons: [{
                    extend: "excelHtml5",
                    className: "hide",
                    autoFilter: true,
                    text: "excel",
                    title: "生產成本分析"
                }, {
                    extend: "csv",
                    className: "hide",
                    autoFilter: true,
                    text: "csv",
                    title: "生產成本分析"
                }]
            });

            this.createDataTable('#tableYear', result.Year.Column, result.Year.Data, {
                bSort: false, searching: false, paging: false, bInfo :false,
                buttons: [{
                    extend: "excelHtml5",
                    className: "hide",
                    autoFilter: true,
                    text: "excel",
                    title: "生產成本分析"
                }, {
                    extend: "csv",
                    className: "hide",
                    autoFilter: true,
                    text: "csv",
                    title: "生產成本分析"
                }]
            });
        },
        exportCSV() {
            $('.tab-pane.active button.buttons-csv').trigger('click');
        },
        exportExcel() {
            $('.tab-pane.active button.buttons-excel').trigger('click');
        },
        async showDetail(time) {
            console.log(time)
            var result = await this.$api.getCostAnalysisData(time);
            this.Time = time;
            var cols = [
                {
                    title: "",
                    data: "Name"
                },
                {
                    title: result.Last,
                    data: "LastMonth"
                },
                {
                    title: "成本增減比",
                    data: "UpDown"
                },
                {
                    title: result.Current,
                    data: "ThisMonth"
                },
                {
                    title: result.Percent,
                    data: "ThisPercent"
                }
            ];
            this.createDataTable('#tableDialog', cols, result.Data.Data, { bSort: false, searching: false, paging: false, bInfo :false });

            function getRandomColor() {
                var letters = '0123456789ABCDEF';
                var color = '#';
                for (var i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }
                return color;
            }

            var chartContainer = $('#canvas-holder');
            chartContainer.empty();
            chartContainer.append(`<canvas id="myChart" width="240" height="240"></canvas>`);
            var labels = [];
            var data = [];
            var backgroundColor = [];

            for(var key in result.Data.Chart){
                labels.push(key);
                data.push(result.Data.Chart[key]);
                backgroundColor.push(getRandomColor())
            }

            var ctx = document.getElementById('myChart');
            var myChart = new Chart(ctx, {
                type: 'pie',
                data: {
                    labels: labels,
                    datasets: [{
                        data: data,
                        backgroundColor: backgroundColor,
                        responsive: true
                    }]
                },


                options: {
                    legend: {
                        display: true,
                        position: 'right',
                        labels: {
                            fontSize: 12,
                            fontStyle: 'bold',
                            fontColor: '#fff',
                            fontFamily: 'Microsoft JhengHei',
                            padding: 30,
                            boxWidth: 24
                        }
                    },
                }

            });
            window.$('#modal-product-cost-analysis').modal();
        }
    }
}